<template>
  <div :class="$style.container">
    <HeadingExtraSmall>
      {{ $options.title }}
    </HeadingExtraSmall>
    <ParagraphBody>
      {{ $options.instructions }}
      <Link
        :href="$options.kbArticleLink"
        isExternal
        target="_blank"
        text="Learn more"
      />
    </ParagraphBody>
    <ul class="jc-clearlist">
      <li :class="$style.option">
        <Checkbox
          v-model="macDevices"
          :isDisabled="disabled"
          label="macOS"
        />
      </li>
      <li :class="$style.option">
        <Checkbox
          v-model="windowsDevices"
          :isDisabled="disabled"
          label="Windows"
        />
      </li>
      <li :class="$style.option">
        <Checkbox
          v-model="linuxDevices"
          :isDisabled="disabled"
          label="Linux"
        />
      </li>
    </ul>
  </div>
</template>

<script>
import {
  Checkbox, HeadingExtraSmall, Link, ParagraphBody,
} from '@jumpcloud/ui-components';
import KbArticleUrls from 'client/util/Constants/KbArticleUrls';
import createComputedObjectBinding from 'client/util/createComputedObjectBinding';

const title = 'Auto enable System Insights on new devices';
const instructions = 'New devices added to JumpCloud will automatically have System Insights enabled. Configure this setting per operating system. Any devices already installed will require enablement on a per system level.';
const kbArticleLink = KbArticleUrls.systemInsights;

export default {
  name: 'FieldsSystemInsights',

  components: {
    Checkbox,
    HeadingExtraSmall,
    Link,
    ParagraphBody,
  },

  props: {
    disabled: Boolean,

    value: {
      type: Object,
      default: () => ({}),
    },
  },

  computed: {
    linuxDevices: {
      ...createComputedObjectBinding('enableNewLinux'),
    },
    macDevices: {
      ...createComputedObjectBinding('enableNewDarwin'),
    },
    windowsDevices: {
      ...createComputedObjectBinding('enableNewWindows'),
    },
  },

  instructions,
  kbArticleLink,
  title,
};
</script>

<style module>
@import '../settings.css';

.container {
  margin-top: 2rem;
  max-width: var(--text-max-width);
}
</style>
